import ListsService from '@/services/ListsService';
export function useBillingTypeLabel() {
  const listsService = new ListsService();
  const billingTypeLabel = entry => {
    if (!entry || !entry.billingType) return '';
    const type = listsService.entryBillingTypes?.find(item => item.id === entry.billingType);
    return type ? type.label : entry.billingType;
  };
  return {
    billingTypeLabel
  };
}